import * as Yup from "yup";

export const phoneAuthStep1Schema = (intl) => {
  return Yup.object().shape({
    verifyCode: Yup.string()
      .nullable(false)
      .required(intl.formatMessage({ id: "verifyCodeRequired" })),
  });
};
